import { __ } from '@wordpress/i18n';
import {
	useBlockProps,
	RichText,
	BlockControls,
	AlignmentToolbar,
	InspectorControls,
	MediaUpload,
} from '@wordpress/block-editor';
import classnames from 'classnames';
import './editor.scss';
import {
	PanelBody,
	ToggleControl,
	Button,
	ComboboxControl,
} from '@wordpress/components';
import { useState } from '@wordpress/element';
const agentImage = require( './images/user.jpg' );

const { SelectControl, TextControl } = wp.components;

const timezones = [
	{
		value: 'Africa/Abidjan',
		label: __( 'Africa/Abidjan', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Accra',
		label: __( 'Africa/Accra', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Addis_Ababa',
		label: __( 'Africa/Addis_Ababa', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Algiers',
		label: __( 'Africa/Algiers', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Asmara',
		label: __( 'Africa/Asmara', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Asmera',
		label: __( 'Africa/Asmera', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Bamako',
		label: __( 'Africa/Bamako', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Bangui',
		label: __( 'Africa/Bangui', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Banjul',
		label: __( 'Africa/Banjul', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Bissau',
		label: __( 'Africa/Bissau', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Blantyre',
		label: __( 'Africa/Blantyre', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Brazzaville',
		label: __( 'Africa/Brazzaville', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Bujumbura',
		label: __( 'Africa/Bujumbura', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Cairo',
		label: __( 'Africa/Cairo', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Casablanca',
		label: __( 'Africa/Casablanca', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Ceuta',
		label: __( 'Africa/Ceuta', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Conakry',
		label: __( 'Africa/Conakry', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Dakar',
		label: __( 'Africa/Dakar', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Dar_es_Salaam',
		label: __( 'Africa/Dar_es_Salaam', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Djibouti',
		label: __( 'Africa/Djibouti', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Douala',
		label: __( 'Africa/Douala', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/El_Aaiun',
		label: __( 'Africa/El_Aaiun', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Freetown',
		label: __( 'Africa/Freetown', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Gaborone',
		label: __( 'Africa/Gaborone', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Harare',
		label: __( 'Africa/Harare', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Johannesburg',
		label: __( 'Africa/Johannesburg', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Juba',
		label: __( 'Africa/Juba', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Kampala',
		label: __( 'Africa/Kampala', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Khartoum',
		label: __( 'Africa/Khartoum', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Kigali',
		label: __( 'Africa/Kigali', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Kinshasa',
		label: __( 'Africa/Kinshasa', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Lagos',
		label: __( 'Africa/Lagos', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Libreville',
		label: __( 'Africa/Libreville', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Lome',
		label: __( 'Africa/Lome', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Luanda',
		label: __( 'Africa/Luanda', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Lubumbashi',
		label: __( 'Africa/Lubumbashi', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Lusaka',
		label: __( 'Africa/Lusaka', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Malabo',
		label: __( 'Africa/Malabo', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Maputo',
		label: __( 'Africa/Maputo', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Maseru',
		label: __( 'Africa/Maseru', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Mbabane',
		label: __( 'Africa/Mbabane', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Mogadishu',
		label: __( 'Africa/Mogadishu', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Monrovia',
		label: __( 'Africa/Monrovia', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Nairobi',
		label: __( 'Africa/Nairobi', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Ndjamena',
		label: __( 'Africa/Ndjamena', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Niamey',
		label: __( 'Africa/Niamey', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Nouakchott',
		label: __( 'Africa/Nouakchott', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Ouagadougou',
		label: __( 'Africa/Ouagadougou', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Porto-Novo',
		label: __( 'Africa/Porto-Novo', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Sao_Tome',
		label: __( 'Africa/Sao_Tome', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Timbuktu',
		label: __( 'Africa/Timbuktu', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Tripoli',
		label: __( 'Africa/Tripoli', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Tunis',
		label: __( 'Africa/Tunis', 'better-chat-support-pro' ),
	},
	{
		value: 'Africa/Windhoek',
		label: __( 'Africa/Windhoek', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Adak',
		label: __( 'America/Adak', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Anchorage',
		label: __( 'America/Anchorage', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Anguilla',
		label: __( 'America/Anguilla', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Antigua',
		label: __( 'America/Antigua', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Araguaina',
		label: __( 'America/Araguaina', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Argentina/Buenos_Aires',
		label: __( 'America/Argentina/Buenos_Aires', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Argentina/Catamarca',
		label: __( 'America/Argentina/Catamarca', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Argentina/ComodRivadavia',
		label: __( 'America/Argentina/ComodRivadavia', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Argentina/Cordoba',
		label: __( 'America/Argentina/Cordoba', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Argentina/Jujuy',
		label: __( 'America/Argentina/Jujuy', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Argentina/La_Rioja',
		label: __( 'America/Argentina/La_Rioja', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Argentina/Mendoza',
		label: __( 'America/Argentina/Mendoza', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Argentina/Rio_Gallegos',
		label: __( 'America/Argentina/Rio_Gallegos', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Argentina/Salta',
		label: __( 'America/Argentina/Salta', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Argentina/San_Juan',
		label: __( 'America/Argentina/San_Juan', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Argentina/San_Luis',
		label: __( 'America/Argentina/San_Luis', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Argentina/Tucuman',
		label: __( 'America/Argentina/Tucuman', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Argentina/Ushuaia',
		label: __( 'America/Argentina/Ushuaia', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Aruba',
		label: __( 'America/Aruba', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Asuncion',
		label: __( 'America/Asuncion', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Atikokan',
		label: __( 'America/Atikokan', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Atka',
		label: __( 'America/Atka', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Bahia',
		label: __( 'America/Bahia', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Bahia_Banderas',
		label: __( 'America/Bahia_Banderas', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Barbados',
		label: __( 'America/Barbados', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Belem',
		label: __( 'America/Belem', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Belize',
		label: __( 'America/Belize', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Blanc-Sablon',
		label: __( 'America/Blanc-Sablon', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Boa_Vista',
		label: __( 'America/Boa_Vista', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Bogota',
		label: __( 'America/Bogota', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Boise',
		label: __( 'America/Boise', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Buenos_Aires',
		label: __( 'America/Buenos_Aires', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Cambridge_Bay',
		label: __( 'America/Cambridge_Bay', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Campo_Grande',
		label: __( 'America/Campo_Grande', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Cancun',
		label: __( 'America/Cancun', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Caracas',
		label: __( 'America/Caracas', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Catamarca',
		label: __( 'America/Catamarca', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Cayenne',
		label: __( 'America/Cayenne', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Cayman',
		label: __( 'America/Cayman', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Chicago',
		label: __( 'America/Chicago', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Chihuahua',
		label: __( 'America/Chihuahua', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Coral_Harbour',
		label: __( 'America/Coral_Harbour', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Cordoba',
		label: __( 'America/Cordoba', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Costa_Rica',
		label: __( 'America/Costa_Rica', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Creston',
		label: __( 'America/Creston', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Cuiaba',
		label: __( 'America/Cuiaba', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Curacao',
		label: __( 'America/Curacao', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Danmarkshavn',
		label: __( 'America/Danmarkshavn', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Dawson',
		label: __( 'America/Dawson', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Dawson_Creek',
		label: __( 'America/Dawson_Creek', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Denver',
		label: __( 'America/Denver', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Detroit',
		label: __( 'America/Detroit', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Dominica',
		label: __( 'America/Dominica', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Edmonton',
		label: __( 'America/Edmonton', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Eirunepe',
		label: __( 'America/Eirunepe', 'better-chat-support-pro' ),
	},
	{
		value: 'America/El_Salvador',
		label: __( 'America/El_Salvador', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Ensenada',
		label: __( 'America/Ensenada', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Fort_Nelson',
		label: __( 'America/Fort_Nelson', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Fort_Wayne',
		label: __( 'America/Fort_Wayne', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Fortaleza',
		label: __( 'America/Fortaleza', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Glace_Bay',
		label: __( 'America/Glace_Bay', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Godthab',
		label: __( 'America/Godthab', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Goose_Bay',
		label: __( 'America/Goose_Bay', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Grand_Turk',
		label: __( 'America/Grand_Turk', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Grenada',
		label: __( 'America/Grenada', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Guadeloupe',
		label: __( 'America/Guadeloupe', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Guatemala',
		label: __( 'America/Guatemala', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Guayaquil',
		label: __( 'America/Guayaquil', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Guyana',
		label: __( 'America/Guyana', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Halifax',
		label: __( 'America/Halifax', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Havana',
		label: __( 'America/Havana', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Hermosillo',
		label: __( 'America/Hermosillo', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Indiana/Indianapolis',
		label: __( 'America/Indiana/Indianapolis', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Indiana/Knox',
		label: __( 'America/Indiana/Knox', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Indiana/Marengo',
		label: __( 'America/Indiana/Marengo', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Indiana/Petersburg',
		label: __( 'America/Indiana/Petersburg', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Indiana/Tell_City',
		label: __( 'America/Indiana/Tell_City', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Indiana/Vevay',
		label: __( 'America/Indiana/Vevay', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Indiana/Vincennes',
		label: __( 'America/Indiana/Vincennes', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Indiana/Winamac',
		label: __( 'America/Indiana/Winamac', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Indianapolis',
		label: __( 'America/Indianapolis', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Inuvik',
		label: __( 'America/Inuvik', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Iqaluit',
		label: __( 'America/Iqaluit', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Jamaica',
		label: __( 'America/Jamaica', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Jujuy',
		label: __( 'America/Jujuy', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Juneau',
		label: __( 'America/Juneau', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Kentucky/Louisville',
		label: __( 'America/Kentucky/Louisville', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Kentucky/Monticello',
		label: __( 'America/Kentucky/Monticello', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Knox_IN',
		label: __( 'America/Knox_IN', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Kralendijk',
		label: __( 'America/Kralendijk', 'better-chat-support-pro' ),
	},
	{
		value: 'America/La_Paz',
		label: __( 'America/La_Paz', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Lima',
		label: __( 'America/Lima', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Los_Angeles',
		label: __( 'America/Los_Angeles', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Louisville',
		label: __( 'America/Louisville', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Lower_Princes',
		label: __( 'America/Lower_Princes', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Maceio',
		label: __( 'America/Maceio', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Managua',
		label: __( 'America/Managua', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Manaus',
		label: __( 'America/Manaus', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Marigot',
		label: __( 'America/Marigot', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Martinique',
		label: __( 'America/Martinique', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Matamoros',
		label: __( 'America/Matamoros', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Mazatlan',
		label: __( 'America/Mazatlan', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Mendoza',
		label: __( 'America/Mendoza', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Menominee',
		label: __( 'America/Menominee', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Merida',
		label: __( 'America/Merida', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Metlakatla',
		label: __( 'America/Metlakatla', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Mexico_City',
		label: __( 'America/Mexico_City', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Miquelon',
		label: __( 'America/Miquelon', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Moncton',
		label: __( 'America/Moncton', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Monterrey',
		label: __( 'America/Monterrey', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Montevideo',
		label: __( 'America/Montevideo', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Montreal',
		label: __( 'America/Montreal', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Montserrat',
		label: __( 'America/Montserrat', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Nassau',
		label: __( 'America/Nassau', 'better-chat-support-pro' ),
	},
	{
		value: 'America/New_York',
		label: __( 'America/New_York', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Nipigon',
		label: __( 'America/Nipigon', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Nome',
		label: __( 'America/Nome', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Noronha',
		label: __( 'America/Noronha', 'better-chat-support-pro' ),
	},
	{
		value: 'America/North_Dakota/Beulah',
		label: __( 'America/North_Dakota/Beulah', 'better-chat-support-pro' ),
	},
	{
		value: 'America/North_Dakota/Center',
		label: __( 'America/North_Dakota/Center', 'better-chat-support-pro' ),
	},
	{
		value: 'America/North_Dakota/New_Salem',
		label: __( 'America/North_Dakota/New_Salem', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Ojinaga',
		label: __( 'America/Ojinaga', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Panama',
		label: __( 'America/Panama', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Pangnirtung',
		label: __( 'America/Pangnirtung', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Paramaribo',
		label: __( 'America/Paramaribo', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Phoenix',
		label: __( 'America/Phoenix', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Port-au-Prince',
		label: __( 'America/Port-au-Prince', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Port_of_Spain',
		label: __( 'America/Port_of_Spain', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Porto_Acre',
		label: __( 'America/Porto_Acre', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Porto_Velho',
		label: __( 'America/Porto_Velho', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Puerto_Rico',
		label: __( 'America/Puerto_Rico', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Punta_Arenas',
		label: __( 'America/Punta_Arenas', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Rainy_River',
		label: __( 'America/Rainy_River', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Rankin_Inlet',
		label: __( 'America/Rankin_Inlet', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Recife',
		label: __( 'America/Recife', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Regina',
		label: __( 'America/Regina', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Resolute',
		label: __( 'America/Resolute', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Rio_Branco',
		label: __( 'America/Rio_Branco', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Rosario',
		label: __( 'America/Rosario', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Santa_Isabel',
		label: __( 'America/Santa_Isabel', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Santarem',
		label: __( 'America/Santarem', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Santiago',
		label: __( 'America/Santiago', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Santo_Domingo',
		label: __( 'America/Santo_Domingo', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Sao_Paulo',
		label: __( 'America/Sao_Paulo', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Scoresbysund',
		label: __( 'America/Scoresbysund', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Shiprock',
		label: __( 'America/Shiprock', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Sitka',
		label: __( 'America/Sitka', 'better-chat-support-pro' ),
	},
	{
		value: 'America/St_Barthelemy',
		label: __( 'America/St_Barthelemy', 'better-chat-support-pro' ),
	},
	{
		value: 'America/St_Johns',
		label: __( 'America/St_Johns', 'better-chat-support-pro' ),
	},
	{
		value: 'America/St_Kitts',
		label: __( 'America/St_Kitts', 'better-chat-support-pro' ),
	},
	{
		value: 'America/St_Lucia',
		label: __( 'America/St_Lucia', 'better-chat-support-pro' ),
	},
	{
		value: 'America/St_Thomas',
		label: __( 'America/St_Thomas', 'better-chat-support-pro' ),
	},
	{
		value: 'America/St_Vincent',
		label: __( 'America/St_Vincent', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Swift_Current',
		label: __( 'America/Swift_Current', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Tegucigalpa',
		label: __( 'America/Tegucigalpa', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Thule',
		label: __( 'America/Thule', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Thunder_Bay',
		label: __( 'America/Thunder_Bay', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Tijuana',
		label: __( 'America/Tijuana', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Toronto',
		label: __( 'America/Toronto', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Tortola',
		label: __( 'America/Tortola', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Vancouver',
		label: __( 'America/Vancouver', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Virgin',
		label: __( 'America/Virgin', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Whitehorse',
		label: __( 'America/Whitehorse', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Winnipeg',
		label: __( 'America/Winnipeg', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Yakutat',
		label: __( 'America/Yakutat', 'better-chat-support-pro' ),
	},
	{
		value: 'America/Yellowknife',
		label: __( 'America/Yellowknife', 'better-chat-support-pro' ),
	},
	{
		value: 'Antarctica/Casey',
		label: __( 'Antarctica/Casey', 'better-chat-support-pro' ),
	},
	{
		value: 'Antarctica/Davis',
		label: __( 'Antarctica/Davis', 'better-chat-support-pro' ),
	},
	{
		value: 'Antarctica/DumontDUrville',
		label: __( 'Antarctica/DumontDUrville', 'better-chat-support-pro' ),
	},
	{
		value: 'Antarctica/Macquarie',
		label: __( 'Antarctica/Macquarie', 'better-chat-support-pro' ),
	},
	{
		value: 'Antarctica/Mawson',
		label: __( 'Antarctica/Mawson', 'better-chat-support-pro' ),
	},
	{
		value: 'Antarctica/McMurdo',
		label: __( 'Antarctica/McMurdo', 'better-chat-support-pro' ),
	},
	{
		value: 'Antarctica/Palmer',
		label: __( 'Antarctica/Palmer', 'better-chat-support-pro' ),
	},
	{
		value: 'Antarctica/Rothera',
		label: __( 'Antarctica/Rothera', 'better-chat-support-pro' ),
	},
	{
		value: 'Antarctica/South_Pole',
		label: __( 'Antarctica/South_Pole', 'better-chat-support-pro' ),
	},
	{
		value: 'Antarctica/Syowa',
		label: __( 'Antarctica/Syowa', 'better-chat-support-pro' ),
	},
	{
		value: 'Antarctica/Troll',
		label: __( 'Antarctica/Troll', 'better-chat-support-pro' ),
	},
	{
		value: 'Antarctica/Vostok',
		label: __( 'Antarctica/Vostok', 'better-chat-support-pro' ),
	},
	{
		value: 'Arctic/Longyearbyen',
		label: __( 'Arctic/Longyearbyen', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Aden',
		label: __( 'Asia/Aden', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Almaty',
		label: __( 'Asia/Almaty', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Amman',
		label: __( 'Asia/Amman', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Anadyr',
		label: __( 'Asia/Anadyr', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Aqtau',
		label: __( 'Asia/Aqtau', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Aqtobe',
		label: __( 'Asia/Aqtobe', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Ashgabat',
		label: __( 'Asia/Ashgabat', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Ashkhabad',
		label: __( 'Asia/Ashkhabad', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Atyrau',
		label: __( 'Asia/Atyrau', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Baghdad',
		label: __( 'Asia/Baghdad', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Bahrain',
		label: __( 'Asia/Bahrain', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Baku',
		label: __( 'Asia/Baku', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Bangkok',
		label: __( 'Asia/Bangkok', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Barnaul',
		label: __( 'Asia/Barnaul', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Beirut',
		label: __( 'Asia/Beirut', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Bishkek',
		label: __( 'Asia/Bishkek', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Brunei',
		label: __( 'Asia/Brunei', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Calcutta',
		label: __( 'Asia/Calcutta', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Chita',
		label: __( 'Asia/Chita', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Choibalsan',
		label: __( 'Asia/Choibalsan', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Chongqing',
		label: __( 'Asia/Chongqing', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Chungking',
		label: __( 'Asia/Chungking', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Colombo',
		label: __( 'Asia/Colombo', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Dacca',
		label: __( 'Asia/Dacca', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Damascus',
		label: __( 'Asia/Damascus', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Dhaka',
		label: __( 'Asia/Dhaka', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Dili',
		label: __( 'Asia/Dili', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Dubai',
		label: __( 'Asia/Dubai', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Dushanbe',
		label: __( 'Asia/Dushanbe', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Famagusta',
		label: __( 'Asia/Famagusta', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Gaza',
		label: __( 'Asia/Gaza', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Harbin',
		label: __( 'Asia/Harbin', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Hebron',
		label: __( 'Asia/Hebron', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Ho_Chi_Minh',
		label: __( 'Asia/Ho_Chi_Minh', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Hong_Kong',
		label: __( 'Asia/Hong_Kong', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Hovd',
		label: __( 'Asia/Hovd', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Irkutsk',
		label: __( 'Asia/Irkutsk', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Istanbul',
		label: __( 'Asia/Istanbul', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Jakarta',
		label: __( 'Asia/Jakarta', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Jayapura',
		label: __( 'Asia/Jayapura', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Jerusalem',
		label: __( 'Asia/Jerusalem', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Kabul',
		label: __( 'Asia/Kabul', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Kamchatka',
		label: __( 'Asia/Kamchatka', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Karachi',
		label: __( 'Asia/Karachi', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Kashgar',
		label: __( 'Asia/Kashgar', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Kathmandu',
		label: __( 'Asia/Kathmandu', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Katmandu',
		label: __( 'Asia/Katmandu', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Khandyga',
		label: __( 'Asia/Khandyga', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Kolkata',
		label: __( 'Asia/Kolkata', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Krasnoyarsk',
		label: __( 'Asia/Krasnoyarsk', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Kuala_Lumpur',
		label: __( 'Asia/Kuala_Lumpur', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Kuching',
		label: __( 'Asia/Kuching', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Kuwait',
		label: __( 'Asia/Kuwait', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Macao',
		label: __( 'Asia/Macao', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Macau',
		label: __( 'Asia/Macau', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Magadan',
		label: __( 'Asia/Magadan', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Makassar',
		label: __( 'Asia/Makassar', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Manila',
		label: __( 'Asia/Manila', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Muscat',
		label: __( 'Asia/Muscat', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Nicosia',
		label: __( 'Asia/Nicosia', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Novokuznetsk',
		label: __( 'Asia/Novokuznetsk', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Novosibirsk',
		label: __( 'Asia/Novosibirsk', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Omsk',
		label: __( 'Asia/Omsk', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Oral',
		label: __( 'Asia/Oral', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Phnom_Penh',
		label: __( 'Asia/Phnom_Penh', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Pontianak',
		label: __( 'Asia/Pontianak', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Pyongyang',
		label: __( 'Asia/Pyongyang', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Qatar',
		label: __( 'Asia/Qatar', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Qyzylorda',
		label: __( 'Asia/Qyzylorda', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Rangoon',
		label: __( 'Asia/Rangoon', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Riyadh',
		label: __( 'Asia/Riyadh', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Saigon',
		label: __( 'Asia/Saigon', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Sakhalin',
		label: __( 'Asia/Sakhalin', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Samarkand',
		label: __( 'Asia/Samarkand', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Seoul',
		label: __( 'Asia/Seoul', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Shanghai',
		label: __( 'Asia/Shanghai', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Singapore',
		label: __( 'Asia/Singapore', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Srednekolymsk',
		label: __( 'Asia/Srednekolymsk', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Taipei',
		label: __( 'Asia/Taipei', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Tashkent',
		label: __( 'Asia/Tashkent', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Tbilisi',
		label: __( 'Asia/Tbilisi', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Tehran',
		label: __( 'Asia/Tehran', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Tel_Aviv',
		label: __( 'Asia/Tel_Aviv', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Thimbu',
		label: __( 'Asia/Thimbu', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Thimphu',
		label: __( 'Asia/Thimphu', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Tokyo',
		label: __( 'Asia/Tokyo', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Tomsk',
		label: __( 'Asia/Tomsk', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Ujung_Pandang',
		label: __( 'Asia/Ujung_Pandang', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Ulaanbaatar',
		label: __( 'Asia/Ulaanbaatar', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Ulan_Bator',
		label: __( 'Asia/Ulan_Bator', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Urumqi',
		label: __( 'Asia/Urumqi', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Ust-Nera',
		label: __( 'Asia/Ust-Nera', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Vientiane',
		label: __( 'Asia/Vientiane', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Vladivostok',
		label: __( 'Asia/Vladivostok', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Yakutsk',
		label: __( 'Asia/Yakutsk', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Yangon',
		label: __( 'Asia/Yangon', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Yekaterinburg',
		label: __( 'Asia/Yekaterinburg', 'better-chat-support-pro' ),
	},
	{
		value: 'Asia/Yerevan',
		label: __( 'Asia/Yerevan', 'better-chat-support-pro' ),
	},
	{
		value: 'Atlantic/Azores',
		label: __( 'Atlantic/Azores', 'better-chat-support-pro' ),
	},
	{
		value: 'Atlantic/Bermuda',
		label: __( 'Atlantic/Bermuda', 'better-chat-support-pro' ),
	},
	{
		value: 'Atlantic/Canary',
		label: __( 'Atlantic/Canary', 'better-chat-support-pro' ),
	},
	{
		value: 'Atlantic/Cape_Verde',
		label: __( 'Atlantic/Cape_Verde', 'better-chat-support-pro' ),
	},
	{
		value: 'Atlantic/Faeroe',
		label: __( 'Atlantic/Faeroe', 'better-chat-support-pro' ),
	},
	{
		value: 'Atlantic/Faroe',
		label: __( 'Atlantic/Faroe', 'better-chat-support-pro' ),
	},
	{
		value: 'Atlantic/Jan_Mayen',
		label: __( 'Atlantic/Jan_Mayen', 'better-chat-support-pro' ),
	},
	{
		value: 'Atlantic/Madeira',
		label: __( 'Atlantic/Madeira', 'better-chat-support-pro' ),
	},
	{
		value: 'Atlantic/Reykjavik',
		label: __( 'Atlantic/Reykjavik', 'better-chat-support-pro' ),
	},
	{
		value: 'Atlantic/South_Georgia',
		label: __( 'Atlantic/South_Georgia', 'better-chat-support-pro' ),
	},
	{
		value: 'Atlantic/St_Helena',
		label: __( 'Atlantic/St_Helena', 'better-chat-support-pro' ),
	},
	{
		value: 'Atlantic/Stanley',
		label: __( 'Atlantic/Stanley', 'better-chat-support-pro' ),
	},
	{
		value: 'Australia/ACT',
		label: __( 'Australia/ACT', 'better-chat-support-pro' ),
	},
	{
		value: 'Australia/Adelaide',
		label: __( 'Australia/Adelaide', 'better-chat-support-pro' ),
	},
	{
		value: 'Australia/Brisbane',
		label: __( 'Australia/Brisbane', 'better-chat-support-pro' ),
	},
	{
		value: 'Australia/Broken_Hill',
		label: __( 'Australia/Broken_Hill', 'better-chat-support-pro' ),
	},
	{
		value: 'Australia/Canberra',
		label: __( 'Australia/Canberra', 'better-chat-support-pro' ),
	},
	{
		value: 'Australia/Currie',
		label: __( 'Australia/Currie', 'better-chat-support-pro' ),
	},
	{
		value: 'Australia/Darwin',
		label: __( 'Australia/Darwin', 'better-chat-support-pro' ),
	},
	{
		value: 'Australia/Eucla',
		label: __( 'Australia/Eucla', 'better-chat-support-pro' ),
	},
	{
		value: 'Australia/Hobart',
		label: __( 'Australia/Hobart', 'better-chat-support-pro' ),
	},
	{
		value: 'Australia/LHI',
		label: __( 'Australia/LHI', 'better-chat-support-pro' ),
	},
	{
		value: 'Australia/Lindeman',
		label: __( 'Australia/Lindeman', 'better-chat-support-pro' ),
	},
	{
		value: 'Australia/Lord_Howe',
		label: __( 'Australia/Lord_Howe', 'better-chat-support-pro' ),
	},
	{
		value: 'Australia/Melbourne',
		label: __( 'Australia/Melbourne', 'better-chat-support-pro' ),
	},
	{
		value: 'Australia/NSW',
		label: __( 'Australia/NSW', 'better-chat-support-pro' ),
	},
	{
		value: 'Australia/North',
		label: __( 'Australia/North', 'better-chat-support-pro' ),
	},
	{
		value: 'Australia/Perth',
		label: __( 'Australia/Perth', 'better-chat-support-pro' ),
	},
	{
		value: 'Australia/Queensland',
		label: __( 'Australia/Queensland', 'better-chat-support-pro' ),
	},
	{
		value: 'Australia/South',
		label: __( 'Australia/South', 'better-chat-support-pro' ),
	},
	{
		value: 'Australia/Sydney',
		label: __( 'Australia/Sydney', 'better-chat-support-pro' ),
	},
	{
		value: 'Australia/Tasmania',
		label: __( 'Australia/Tasmania', 'better-chat-support-pro' ),
	},
	{
		value: 'Australia/Victoria',
		label: __( 'Australia/Victoria', 'better-chat-support-pro' ),
	},
	{
		value: 'Australia/West',
		label: __( 'Australia/West', 'better-chat-support-pro' ),
	},
	{
		value: 'Australia/Yancowinna',
		label: __( 'Australia/Yancowinna', 'better-chat-support-pro' ),
	},
	{
		value: 'Brazil/Acre',
		label: __( 'Brazil/Acre', 'better-chat-support-pro' ),
	},
	{
		value: 'Brazil/DeNoronha',
		label: __( 'Brazil/DeNoronha', 'better-chat-support-pro' ),
	},
	{
		value: 'Brazil/East',
		label: __( 'Brazil/East', 'better-chat-support-pro' ),
	},
	{
		value: 'Brazil/West',
		label: __( 'Brazil/West', 'better-chat-support-pro' ),
	},
	{
		value: 'CET',
		label: __( 'CET', 'better-chat-support-pro' ),
	},
	{
		value: 'CST6CDT',
		label: __( 'CST6CDT', 'better-chat-support-pro' ),
	},
	{
		value: 'Canada/Atlantic',
		label: __( 'Canada/Atlantic', 'better-chat-support-pro' ),
	},
	{
		value: 'Canada/Central',
		label: __( 'Canada/Central', 'better-chat-support-pro' ),
	},
	{
		value: 'Canada/Eastern',
		label: __( 'Canada/Eastern', 'better-chat-support-pro' ),
	},
	{
		value: 'Canada/Mountain',
		label: __( 'Canada/Mountain', 'better-chat-support-pro' ),
	},
	{
		value: 'Canada/Newfoundland',
		label: __( 'Canada/Newfoundland', 'better-chat-support-pro' ),
	},
	{
		value: 'Canada/Pacific',
		label: __( 'Canada/Pacific', 'better-chat-support-pro' ),
	},
	{
		value: 'Canada/Saskatchewan',
		label: __( 'Canada/Saskatchewan', 'better-chat-support-pro' ),
	},
	{
		value: 'Canada/Yukon',
		label: __( 'Canada/Yukon', 'better-chat-support-pro' ),
	},
	{
		value: 'Chile/Continental',
		label: __( 'Chile/Continental', 'better-chat-support-pro' ),
	},
	{
		value: 'Chile/EasterIsland',
		label: __( 'Chile/EasterIsland', 'better-chat-support-pro' ),
	},
	{
		value: 'Cuba',
		label: __( 'Cuba', 'better-chat-support-pro' ),
	},
	{
		value: 'EET',
		label: __( 'EET', 'better-chat-support-pro' ),
	},
	{
		value: 'EST',
		label: __( 'EST', 'better-chat-support-pro' ),
	},
	{
		value: 'EST5EDT',
		label: __( 'EST5EDT', 'better-chat-support-pro' ),
	},
	{
		value: 'Egypt',
		label: __( 'Egypt', 'better-chat-support-pro' ),
	},
	{
		value: 'Eire',
		label: __( 'Eire', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/GMT',
		label: __( 'Etc/GMT', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/GMT+0',
		label: __( 'Etc/GMT+0', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/GMT+1',
		label: __( 'Etc/GMT+1', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/GMT+10',
		label: __( 'Etc/GMT+10', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/GMT+11',
		label: __( 'Etc/GMT+11', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/GMT+12',
		label: __( 'Etc/GMT+12', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/GMT+2',
		label: __( 'Etc/GMT+2', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/GMT+3',
		label: __( 'Etc/GMT+3', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/GMT+4',
		label: __( 'Etc/GMT+4', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/GMT+5',
		label: __( 'Etc/GMT+5', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/GMT+6',
		label: __( 'Etc/GMT+6', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/GMT+7',
		label: __( 'Etc/GMT+7', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/GMT+8',
		label: __( 'Etc/GMT+8', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/GMT+9',
		label: __( 'Etc/GMT+9', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/GMT-0',
		label: __( 'Etc/GMT-0', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/GMT-1',
		label: __( 'Etc/GMT-1', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/GMT-10',
		label: __( 'Etc/GMT-10', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/GMT-11',
		label: __( 'Etc/GMT-11', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/GMT-12',
		label: __( 'Etc/GMT-12', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/GMT-13',
		label: __( 'Etc/GMT-13', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/GMT-14',
		label: __( 'Etc/GMT-14', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/GMT-2',
		label: __( 'Etc/GMT-2', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/GMT-3',
		label: __( 'Etc/GMT-3', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/GMT-4',
		label: __( 'Etc/GMT-4', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/GMT-5',
		label: __( 'Etc/GMT-5', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/GMT-6',
		label: __( 'Etc/GMT-6', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/GMT-7',
		label: __( 'Etc/GMT-7', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/GMT-8',
		label: __( 'Etc/GMT-8', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/GMT-9',
		label: __( 'Etc/GMT-9', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/GMT0',
		label: __( 'Etc/GMT0', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/Greenwich',
		label: __( 'Etc/Greenwich', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/UCT',
		label: __( 'Etc/UCT', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/UTC',
		label: __( 'Etc/UTC', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/Universal',
		label: __( 'Etc/Universal', 'better-chat-support-pro' ),
	},
	{
		value: 'Etc/Zulu',
		label: __( 'Etc/Zulu', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Amsterdam',
		label: __( 'Europe/Amsterdam', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Andorra',
		label: __( 'Europe/Andorra', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Astrakhan',
		label: __( 'Europe/Astrakhan', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Athens',
		label: __( 'Europe/Athens', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Belfast',
		label: __( 'Europe/Belfast', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Belgrade',
		label: __( 'Europe/Belgrade', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Berlin',
		label: __( 'Europe/Berlin', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Bratislava',
		label: __( 'Europe/Bratislava', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Brussels',
		label: __( 'Europe/Brussels', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Bucharest',
		label: __( 'Europe/Bucharest', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Budapest',
		label: __( 'Europe/Budapest', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Busingen',
		label: __( 'Europe/Busingen', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Chisinau',
		label: __( 'Europe/Chisinau', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Copenhagen',
		label: __( 'Europe/Copenhagen', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Dublin',
		label: __( 'Europe/Dublin', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Gibraltar',
		label: __( 'Europe/Gibraltar', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Guernsey',
		label: __( 'Europe/Guernsey', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Helsinki',
		label: __( 'Europe/Helsinki', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Isle_of_Man',
		label: __( 'Europe/Isle_of_Man', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Istanbul',
		label: __( 'Europe/Istanbul', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Jersey',
		label: __( 'Europe/Jersey', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Kaliningrad',
		label: __( 'Europe/Kaliningrad', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Kiev',
		label: __( 'Europe/Kiev', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Kirov',
		label: __( 'Europe/Kirov', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Lisbon',
		label: __( 'Europe/Lisbon', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Ljubljana',
		label: __( 'Europe/Ljubljana', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/London',
		label: __( 'Europe/London', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Luxembourg',
		label: __( 'Europe/Luxembourg', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Madrid',
		label: __( 'Europe/Madrid', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Malta',
		label: __( 'Europe/Malta', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Mariehamn',
		label: __( 'Europe/Mariehamn', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Minsk',
		label: __( 'Europe/Minsk', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Monaco',
		label: __( 'Europe/Monaco', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Moscow',
		label: __( 'Europe/Moscow', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Nicosia',
		label: __( 'Europe/Nicosia', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Oslo',
		label: __( 'Europe/Oslo', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Paris',
		label: __( 'Europe/Paris', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Podgorica',
		label: __( 'Europe/Podgorica', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Prague',
		label: __( 'Europe/Prague', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Riga',
		label: __( 'Europe/Riga', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Rome',
		label: __( 'Europe/Rome', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Samara',
		label: __( 'Europe/Samara', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/San_Marino',
		label: __( 'Europe/San_Marino', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Sarajevo',
		label: __( 'Europe/Sarajevo', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Saratov',
		label: __( 'Europe/Saratov', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Simferopol',
		label: __( 'Europe/Simferopol', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Skopje',
		label: __( 'Europe/Skopje', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Sofia',
		label: __( 'Europe/Sofia', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Stockholm',
		label: __( 'Europe/Stockholm', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Tallinn',
		label: __( 'Europe/Tallinn', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Tirane',
		label: __( 'Europe/Tirane', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Tiraspol',
		label: __( 'Europe/Tiraspol', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Ulyanovsk',
		label: __( 'Europe/Ulyanovsk', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Uzhgorod',
		label: __( 'Europe/Uzhgorod', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Vaduz',
		label: __( 'Europe/Vaduz', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Vatican',
		label: __( 'Europe/Vatican', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Vienna',
		label: __( 'Europe/Vienna', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Vilnius',
		label: __( 'Europe/Vilnius', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Volgograd',
		label: __( 'Europe/Volgograd', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Warsaw',
		label: __( 'Europe/Warsaw', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Zagreb',
		label: __( 'Europe/Zagreb', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Zaporozhye',
		label: __( 'Europe/Zaporozhye', 'better-chat-support-pro' ),
	},
	{
		value: 'Europe/Zurich',
		label: __( 'Europe/Zurich', 'better-chat-support-pro' ),
	},
	{
		value: 'GB',
		label: __( 'GB', 'better-chat-support-pro' ),
	},
	{
		value: 'GB-Eire',
		label: __( 'GB-Eire', 'better-chat-support-pro' ),
	},
	{
		value: 'GMT',
		label: __( 'GMT', 'better-chat-support-pro' ),
	},
	{
		value: 'GMT+0',
		label: __( 'GMT+0', 'better-chat-support-pro' ),
	},
	{
		value: 'GMT-0',
		label: __( 'GMT-0', 'better-chat-support-pro' ),
	},
	{
		value: 'GMT0',
		label: __( 'GMT0', 'better-chat-support-pro' ),
	},
	{
		value: 'Greenwich',
		label: __( 'Greenwich', 'better-chat-support-pro' ),
	},
	{
		value: 'HST',
		label: __( 'HST', 'better-chat-support-pro' ),
	},
	{
		value: 'Hongkong',
		label: __( 'Hongkong', 'better-chat-support-pro' ),
	},
	{
		value: 'Iceland',
		label: __( 'Iceland', 'better-chat-support-pro' ),
	},
	{
		value: 'Indian/Antananarivo',
		label: __( 'Indian/Antananarivo', 'better-chat-support-pro' ),
	},
	{
		value: 'Indian/Chagos',
		label: __( 'Indian/Chagos', 'better-chat-support-pro' ),
	},
	{
		value: 'Indian/Christmas',
		label: __( 'Indian/Christmas', 'better-chat-support-pro' ),
	},
	{
		value: 'Indian/Cocos',
		label: __( 'Indian/Cocos', 'better-chat-support-pro' ),
	},
	{
		value: 'Indian/Comoro',
		label: __( 'Indian/Comoro', 'better-chat-support-pro' ),
	},
	{
		value: 'Indian/Kerguelen',
		label: __( 'Indian/Kerguelen', 'better-chat-support-pro' ),
	},
	{
		value: 'Indian/Mahe',
		label: __( 'Indian/Mahe', 'better-chat-support-pro' ),
	},
	{
		value: 'Indian/Maldives',
		label: __( 'Indian/Maldives', 'better-chat-support-pro' ),
	},
	{
		value: 'Indian/Mauritius',
		label: __( 'Indian/Mauritius', 'better-chat-support-pro' ),
	},
	{
		value: 'Indian/Mayotte',
		label: __( 'Indian/Mayotte', 'better-chat-support-pro' ),
	},
	{
		value: 'Indian/Reunion',
		label: __( 'Indian/Reunion', 'better-chat-support-pro' ),
	},
	{
		value: 'Iran',
		label: __( 'Iran', 'better-chat-support-pro' ),
	},
	{
		value: 'Israel',
		label: __( 'Israel', 'better-chat-support-pro' ),
	},
	{
		value: 'Jamaica',
		label: __( 'Jamaica', 'better-chat-support-pro' ),
	},
	{
		value: 'Japan',
		label: __( 'Japan', 'better-chat-support-pro' ),
	},
	{
		value: 'Kwajalein',
		label: __( 'Kwajalein', 'better-chat-support-pro' ),
	},
	{
		value: 'Libya',
		label: __( 'Libya', 'better-chat-support-pro' ),
	},
	{
		value: 'MET',
		label: __( 'MET', 'better-chat-support-pro' ),
	},
	{
		value: 'MST',
		label: __( 'MST', 'better-chat-support-pro' ),
	},
	{
		value: 'MST7MDT',
		label: __( 'MST7MDT', 'better-chat-support-pro' ),
	},
	{
		value: 'Mexico/BajaNorte',
		label: __( 'Mexico/BajaNorte', 'better-chat-support-pro' ),
	},
	{
		value: 'Mexico/BajaSur',
		label: __( 'Mexico/BajaSur', 'better-chat-support-pro' ),
	},
	{
		value: 'Mexico/General',
		label: __( 'Mexico/General', 'better-chat-support-pro' ),
	},
	{
		value: 'NZ',
		label: __( 'NZ', 'better-chat-support-pro' ),
	},
	{
		value: 'NZ-CHAT',
		label: __( 'NZ-CHAT', 'better-chat-support-pro' ),
	},
	{
		value: 'Navajo',
		label: __( 'Navajo', 'better-chat-support-pro' ),
	},
	{
		value: 'PRC',
		label: __( 'PRC', 'better-chat-support-pro' ),
	},
	{
		value: 'PST8PDT',
		label: __( 'PST8PDT', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Apia',
		label: __( 'Pacific/Apia', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Auckland',
		label: __( 'Pacific/Auckland', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Bougainville',
		label: __( 'Pacific/Bougainville', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Chatham',
		label: __( 'Pacific/Chatham', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Chuuk',
		label: __( 'Pacific/Chuuk', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Easter',
		label: __( 'Pacific/Easter', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Efate',
		label: __( 'Pacific/Efate', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Enderbury',
		label: __( 'Pacific/Enderbury', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Fakaofo',
		label: __( 'Pacific/Fakaofo', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Fiji',
		label: __( 'Pacific/Fiji', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Funafuti',
		label: __( 'Pacific/Funafuti', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Galapagos',
		label: __( 'Pacific/Galapagos', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Gambier',
		label: __( 'Pacific/Gambier', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Guadalcanal',
		label: __( 'Pacific/Guadalcanal', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Guam',
		label: __( 'Pacific/Guam', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Honolulu',
		label: __( 'Pacific/Honolulu', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Johnston',
		label: __( 'Pacific/Johnston', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Kiritimati',
		label: __( 'Pacific/Kiritimati', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Kosrae',
		label: __( 'Pacific/Kosrae', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Kwajalein',
		label: __( 'Pacific/Kwajalein', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Majuro',
		label: __( 'Pacific/Majuro', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Marquesas',
		label: __( 'Pacific/Marquesas', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Midway',
		label: __( 'Pacific/Midway', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Nauru',
		label: __( 'Pacific/Nauru', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Niue',
		label: __( 'Pacific/Niue', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Norfolk',
		label: __( 'Pacific/Norfolk', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Noumea',
		label: __( 'Pacific/Noumea', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Pago_Pago',
		label: __( 'Pacific/Pago_Pago', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Palau',
		label: __( 'Pacific/Palau', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Pitcairn',
		label: __( 'Pacific/Pitcairn', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Pohnpei',
		label: __( 'Pacific/Pohnpei', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Ponape',
		label: __( 'Pacific/Ponape', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Port_Moresby',
		label: __( 'Pacific/Port_Moresby', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Rarotonga',
		label: __( 'Pacific/Rarotonga', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Saipan',
		label: __( 'Pacific/Saipan', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Samoa',
		label: __( 'Pacific/Samoa', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Tahiti',
		label: __( 'Pacific/Tahiti', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Tarawa',
		label: __( 'Pacific/Tarawa', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Tongatapu',
		label: __( 'Pacific/Tongatapu', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Truk',
		label: __( 'Pacific/Truk', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Wake',
		label: __( 'Pacific/Wake', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Wallis',
		label: __( 'Pacific/Wallis', 'better-chat-support-pro' ),
	},
	{
		value: 'Pacific/Yap',
		label: __( 'Pacific/Yap', 'better-chat-support-pro' ),
	},
	{
		value: 'Poland',
		label: __( 'Poland', 'better-chat-support-pro' ),
	},
	{
		value: 'Portugal',
		label: __( 'Portugal', 'better-chat-support-pro' ),
	},
	{
		value: 'ROC',
		label: __( 'ROC', 'better-chat-support-pro' ),
	},
	{
		value: 'ROK',
		label: __( 'ROK', 'better-chat-support-pro' ),
	},
	{
		value: 'Singapore',
		label: __( 'Singapore', 'better-chat-support-pro' ),
	},
	{
		value: 'Turkey',
		label: __( 'Turkey', 'better-chat-support-pro' ),
	},
	{
		value: 'UCT',
		label: __( 'UCT', 'better-chat-support-pro' ),
	},
	{
		value: 'US/Alaska',
		label: __( 'US/Alaska', 'better-chat-support-pro' ),
	},
	{
		value: 'US/Aleutian',
		label: __( 'US/Aleutian', 'better-chat-support-pro' ),
	},
	{
		value: 'US/Arizona',
		label: __( 'US/Arizona', 'better-chat-support-pro' ),
	},
	{
		value: 'US/Central',
		label: __( 'US/Central', 'better-chat-support-pro' ),
	},
	{
		value: 'US/East-Indiana',
		label: __( 'US/East-Indiana', 'better-chat-support-pro' ),
	},
	{
		value: 'US/Eastern',
		label: __( 'US/Eastern', 'better-chat-support-pro' ),
	},
	{
		value: 'US/Hawaii',
		label: __( 'US/Hawaii', 'better-chat-support-pro' ),
	},
	{
		value: 'US/Indiana-Starke',
		label: __( 'US/Indiana-Starke', 'better-chat-support-pro' ),
	},
	{
		value: 'US/Michigan',
		label: __( 'US/Michigan', 'better-chat-support-pro' ),
	},
	{
		value: 'US/Mountain',
		label: __( 'US/Mountain', 'better-chat-support-pro' ),
	},
	{
		value: 'US/Pacific',
		label: __( 'US/Pacific', 'better-chat-support-pro' ),
	},
	{
		value: 'US/Pacific-New',
		label: __( 'US/Pacific-New', 'better-chat-support-pro' ),
	},
	{
		value: 'US/Samoa',
		label: __( 'US/Samoa', 'better-chat-support-pro' ),
	},
	{
		value: 'UTC',
		label: __( 'UTC', 'better-chat-support-pro' ),
	},
	{
		value: 'Universal',
		label: __( 'Universal', 'better-chat-support-pro' ),
	},
	{
		value: 'W-SU',
		label: __( 'W-SU', 'better-chat-support-pro' ),
	},
	{
		value: 'WET',
		label: __( 'WET', 'better-chat-support-pro' ),
	},
	{
		value: 'Zulu',
		label: __( 'Zulu', 'better-chat-support-pro' ),
	},
];

export default function Edit( props ) {
	const { attributes, setAttributes } = props;

	const {
		buttonSize,
		buttonType,
		borderRadius,
		text,
		info,
		title,
		online,
		offline,
		textAlignment,
		iconTarget,
		visibility,
		buttonLinkTarget,
		numberInput,
		imageUrl,
		timeZone,
		mondayStart,
		mondayEnd,
		tuesdayStart,
		tuesdayEnd,
		wednesdayStart,
		wednesdayEnd,
		thursdayStart,
		thursdayEnd,
		fridayStart,
		fridayEnd,
		saturdayStart,
		saturdayEnd,
		sundayStart,
		sundayEnd,
	} = attributes;

	const [ filteredOptions, setFilteredOptions ] = useState( timezones );

	function onInputChange( value ) {
		setFilteredOptions(
			timezones.filter( ( timezone ) =>
				timezone.label.toLowerCase().includes( value.toLowerCase() )
			)
		);
	}

	function onFontSizeChange( value ) {
		setAttributes( { timeZone: value } );
	}
	const onSelectImage = ( image ) => {
		setAttributes( {
			imageUrl: image.url,
		} );
	};
	const onChangeAlignment = ( newAlignment ) => {
		setAttributes( { textAlignment: newAlignment } );
	};
	const onChangeText = ( newText ) => {
		setAttributes( { text: newText } );
	};
	const advancedBtnInfo = ( newInfo ) => {
		setAttributes( { info: newInfo } );
	};
	const advancedBtnTitle = ( newTitle ) => {
		setAttributes( { title: newTitle } );
	};
	const advancedBtnOnlineBadge = ( newOnline ) => {
		setAttributes( { online: newOnline } );
	};
	const onIconTarget = ( onIconTargets ) => {
		setAttributes( { iconTarget: onIconTargets } );
	};
	const onButtonLinkTarget = ( newLinkTarget ) => {
		setAttributes( { buttonLinkTarget: newLinkTarget } );
	};

	const textClasses = classnames( `mSupportButtons-align-${ textAlignment }` );

	const basicBtn = classnames( `mSupport-button-4 mSupport-btn-bg` );
	const classes = classnames( `mSupportButtons mSupport-button-4 mSupport-btn-bg` );

	const buttonSizeOptions = [
		{ value: 'size-small', label: __( 'Small', 'better-chat-support-pro' ) },
		{ value: 'size-medium', label: __( 'Medium', 'better-chat-support-pro' ) },
		{ value: 'size-large', label: __( 'Large', 'better-chat-support-pro' ) },
	];
	const buttonTypeOptions = [
		{ value: 'basic-button', label: __( 'Basic Button', 'better-chat-support-pro' ) },
		{
			value: 'advance-button',
			label: __( 'Advance Button', 'better-chat-support-pro' ),
		},
	];
	const borderRadiusOptions = [
		{
			value: 'border-squared',
			label: __( 'Border Squared', 'better-chat-support-pro' ),
		},
		{
			value: 'border-rounded',
			label: __( 'Border Rounded', 'better-chat-support-pro' ),
		},
	];
	const visibilityOn = [
		{ value: '', label: __( 'Everywhere', 'better-chat-support-pro' ) },
		{
			value: 'mSupport-desktop-only',
			label: __( 'Desktop only', 'better-chat-support-pro' ),
		},
		{
			value: 'mSupport-tablet-only',
			label: __( 'Tablets only', 'better-chat-support-pro' ),
		},
		{
			value: 'mSupport-mobile-tablet-only',
			label: __( 'Mobile and tablets', 'better-chat-support-pro' ),
		},
		{
			value: 'mSupport-mobile-only',
			label: __( 'Mobile only', 'better-chat-support-pro' ),
		},
	];

	return (
		<>
			<InspectorControls>
				<PanelBody>
					<SelectControl
						label={ __( 'Button Type', 'better-chat-support-pro' ) }
						value={ buttonType }
						options={ buttonTypeOptions.map(
							( { value, label } ) => ( {
								value,
								label,
							} )
						) }
						onChange={ ( newButton ) => {
							setAttributes( { buttonType: newButton } );
						} }
					/>
				</PanelBody>
			</InspectorControls>
			{ buttonType === 'basic-button' ? (
				<>
					<InspectorControls>
						<PanelBody
							title={ __( 'General Settings', 'better-chat-support-pro' ) }
							initialOpen={ false }
						>
							<TextControl
								label={ __( 'Messager User Name', 'better-chat-support-pro' ) }
								value={ numberInput }
								onChange={ ( val ) =>
									setAttributes( { numberInput: val } )
								}
								help={ __(
									'Add your messager user name',
									'better-chat-support-pro'
								) }
							/>
							<ToggleControl
								label={ __(
									'Open link in new window',
									'better-chat-support-pro'
								) }
								checked={ buttonLinkTarget }
								onChange={ onButtonLinkTarget }
							/>
						</PanelBody>
						<PanelBody
							title={ __( 'Button Style', 'better-chat-support-pro' ) }
							initialOpen={ false }
						>
							<TextControl
								label={ __( 'Button Text', 'better-chat-support-pro' ) }
								value={ text }
								onChange={ ( val ) =>
									setAttributes( { text: val } )
								}
							/>
							<SelectControl
								label={ __( 'Button Size', 'better-chat-support-pro' ) }
								value={ buttonSize }
								options={ buttonSizeOptions.map(
									( { value, label } ) => ( {
										value,
										label,
									} )
								) }
								onChange={ ( newSize ) => {
									setAttributes( { buttonSize: newSize } );
								} }
							/>
							<SelectControl
								label={ __( 'Border Radius', 'better-chat-support-pro' ) }
								value={ borderRadius }
								options={ borderRadiusOptions.map(
									( { value, label } ) => ( {
										value,
										label,
									} )
								) }
								onChange={ ( newSize ) => {
									setAttributes( { borderRadius: newSize } );
								} }
							/>
							<SelectControl
								label={ __( 'Visibility on', 'better-chat-support-pro' ) }
								value={ visibility }
								options={ visibilityOn.map(
									( { value, label } ) => ( {
										value,
										label,
									} )
								) }
								onChange={ ( newSize ) => {
									setAttributes( { visibility: newSize } );
								} }
							/>
						</PanelBody>
						<PanelBody
							title={ __( 'Icon', 'better-chat-support-pro' ) }
							initialOpen={ false }
						>
							<ToggleControl
								label={ __( 'Add Icon', 'better-chat-support-pro' ) }
								checked={ iconTarget }
								onChange={ onIconTarget }
							/>
						</PanelBody>
					</InspectorControls>
					<BlockControls>
						<AlignmentToolbar
							value={ textAlignment }
							onChange={ onChangeAlignment }
						/>
					</BlockControls>
					<div
						className={ `button-wrapper mSupport-editor ${ textClasses }` }
					>
						<a
							{ ...useBlockProps( {
								className: `${ basicBtn } ${ buttonSize } ${ borderRadius } ${ visibility }`,
							} ) }
						>
							{ iconTarget && (
								<span className="dashicons dashicons-format-status"></span>
							) }
							<RichText
								onChange={ onChangeText }
								value={ text }
								placeholder={ __(
									'How can I help you?',
									'better-chat-support-pro'
								) }
								tagName="span"
								allowedFormats={ [] }
							/>
						</a>
					</div>
				</>
			) : (
				<>
					<InspectorControls>
						<PanelBody
							title={ __( 'General Settings', 'better-chat-support-pro' ) }
							initialOpen={ false }
						>
							<TextControl
								label={ __( 'Messanger User Name', 'better-chat-support-pro' ) }
								value={ numberInput }
								onChange={ ( val ) =>
									setAttributes( { numberInput: val } )
								}
								help={ __(
									'Add your messanger user name',
									'better-chat-support-pro'
								) }
							/>
							<ToggleControl
								label={ __(
									'Open link in new window',
									'better-chat-support-pro'
								) }
								checked={ buttonLinkTarget }
								onChange={ onButtonLinkTarget }
							/>
							<MediaUpload
								label={ __( 'Agent Image', 'better-chat-support-pro' ) }
								onSelect={ onSelectImage }
								allowedTypes={ [ 'image' ] }
								render={ ( { open } ) => (
									<Button
										onClick={ open }
										style={ {
											marginBottom: '20px',
											fontSize: '16px',
										} }
									>
										<span
											style={ { marginRight: '5px' } }
											className="dashicons dashicons-cloud-upload"
										></span>{ ' ' }
										Agent photo
									</Button>
								) }
							/>
							<TextControl
								label={ __( 'Agent Info', 'better-chat-support-pro' ) }
								value={ info }
								onChange={ ( val ) =>
									setAttributes( { info: val } )
								}
								help={ __(
									'Write agent name & agent title',
									'better-chat-support-pro'
								) }
							/>
							<TextControl
								label={ __( 'Button Label', 'better-chat-support-pro' ) }
								value={ title }
								onChange={ ( val ) =>
									setAttributes( { title: val } )
								}
								help={ __(
									'Add custom button label',
									'better-chat-support-pro'
								) }
							/>
							<TextControl
								label={ __(
									'Online Badge Text',
									'better-chat-support-pro'
								) }
								value={ online }
								onChange={ ( val ) =>
									setAttributes( { online: val } )
								}
								help={ __(
									'Add custom badget text when user in online.',
									'better-chat-support-pro'
								) }
							/>
							<TextControl
								label={ __(
									'Offline Badge Text',
									'better-chat-support-pro'
								) }
								value={ offline }
								onChange={ ( val ) =>
									setAttributes( { offline: val } )
								}
								help={ __(
									'Add custom badget text when user in offline.',
									'better-chat-support-pro'
								) }
							/>
						</PanelBody>
						<PanelBody
							title={ __( 'Chat Settings', 'better-chat-support-pro' ) }
							initialOpen={ false }
						>
							<ComboboxControl
								label={ __( 'Timezone', 'better-chat-support-pro' ) }
								value={ timeZone }
								options={ filteredOptions }
								onChange={ onFontSizeChange }
								onInputChange={ onInputChange }
								help={ __(
									'When using the date and time from the user browser you can transform it to your current timezone (in case your user is in a different timezone)',
									'better-chat-support-pro'
								) }
							/>
							<PanelBody
								title={ __( 'Monthday', 'better-chat-support-pro' ) }
								initialOpen={ false }
							>
								<TextControl
									label={ __( 'Start Time', 'better-chat-support-pro' ) }
									value={ mondayStart }
									onChange={ ( val ) =>
										setAttributes( { mondayStart: val } )
									}
									placeholder={ __(
										'00:00',
										'better-chat-support-pro'
									) }
								/>
								<TextControl
									label={ __( 'End Time', 'better-chat-support-pro' ) }
									value={ mondayEnd }
									onChange={ ( val ) =>
										setAttributes( { mondayEnd: val } )
									}
									placeholder={ __(
										'24:00',
										'better-chat-support-pro'
									) }
								/>
							</PanelBody>
							<PanelBody
								title={ __( 'Tuesday', 'better-chat-support-pro' ) }
								initialOpen={ false }
							>
								<TextControl
									label={ __( 'Start Time', 'better-chat-support-pro' ) }
									value={ tuesdayStart }
									onChange={ ( val ) =>
										setAttributes( { tuesdayStart: val } )
									}
									placeholder={ __(
										'00:00',
										'better-chat-support-pro'
									) }
								/>
								<TextControl
									label={ __( 'End Time', 'better-chat-support-pro' ) }
									value={ tuesdayEnd }
									onChange={ ( val ) =>
										setAttributes( { tuesdayEnd: val } )
									}
									placeholder={ __(
										'24:00',
										'better-chat-support-pro'
									) }
								/>
							</PanelBody>
							<PanelBody
								title={ __( 'Wednesday', 'better-chat-support-pro' ) }
								initialOpen={ false }
							>
								<TextControl
									label={ __( 'Start Time', 'better-chat-support-pro' ) }
									value={ wednesdayStart }
									onChange={ ( val ) =>
										setAttributes( { wednesdayStart: val } )
									}
									placeholder={ __(
										'00:00',
										'better-chat-support-pro'
									) }
								/>
								<TextControl
									label={ __( 'End Time', 'better-chat-support-pro' ) }
									value={ wednesdayEnd }
									onChange={ ( val ) =>
										setAttributes( { wednesdayEnd: val } )
									}
									placeholder={ __(
										'24:00',
										'better-chat-support-pro'
									) }
								/>
							</PanelBody>
							<PanelBody
								title={ __( 'Thursday', 'better-chat-support-pro' ) }
								initialOpen={ false }
							>
								<TextControl
									label={ __( 'Start Time', 'better-chat-support-pro' ) }
									value={ thursdayStart }
									onChange={ ( val ) =>
										setAttributes( { thursdayStart: val } )
									}
									placeholder={ __(
										'00:00',
										'better-chat-support-pro'
									) }
								/>
								<TextControl
									label={ __( 'End Time', 'better-chat-support-pro' ) }
									value={ thursdayEnd }
									onChange={ ( val ) =>
										setAttributes( { thursdayEnd: val } )
									}
									placeholder={ __(
										'24:00',
										'better-chat-support-pro'
									) }
								/>
							</PanelBody>
							<PanelBody
								title={ __( 'Friday', 'better-chat-support-pro' ) }
								initialOpen={ false }
							>
								<TextControl
									label={ __( 'Start Time', 'better-chat-support-pro' ) }
									value={ fridayStart }
									onChange={ ( val ) =>
										setAttributes( { fridayStart: val } )
									}
									placeholder={ __(
										'00:00',
										'better-chat-support-pro'
									) }
								/>
								<TextControl
									label={ __( 'End Time', 'better-chat-support-pro' ) }
									value={ fridayEnd }
									onChange={ ( val ) =>
										setAttributes( { fridayEnd: val } )
									}
									placeholder={ __(
										'24:00',
										'better-chat-support-pro'
									) }
								/>
							</PanelBody>
							<PanelBody
								title={ __( 'Saturday', 'better-chat-support-pro' ) }
								initialOpen={ false }
							>
								<TextControl
									label={ __( 'Start Time', 'better-chat-support-pro' ) }
									value={ saturdayStart }
									onChange={ ( val ) =>
										setAttributes( { saturdayStart: val } )
									}
									placeholder={ __(
										'00:00',
										'better-chat-support-pro'
									) }
								/>
								<TextControl
									label={ __( 'End Time', 'better-chat-support-pro' ) }
									value={ saturdayEnd }
									onChange={ ( val ) =>
										setAttributes( { saturdayEnd: val } )
									}
									placeholder={ __(
										'24:00',
										'better-chat-support-pro'
									) }
								/>
							</PanelBody>
							<PanelBody
								title={ __( 'Sunday', 'better-chat-support-pro' ) }
								initialOpen={ false }
							>
								<TextControl
									label={ __( 'Start Time', 'better-chat-support-pro' ) }
									value={ sundayStart }
									onChange={ ( val ) =>
										setAttributes( { sundayStart: val } )
									}
									placeholder={ __(
										'00:00',
										'better-chat-support-pro'
									) }
								/>
								<TextControl
									label={ __( 'End Time', 'better-chat-support-pro' ) }
									value={ sundayEnd }
									onChange={ ( val ) =>
										setAttributes( { sundayEnd: val } )
									}
									placeholder={ __(
										'24:00',
										'better-chat-support-pro'
									) }
								/>
							</PanelBody>
						</PanelBody>
						<PanelBody
							title={ __(
								'Appearance settings',
								'better-chat-support-pro'
							) }
							initialOpen={ false }
						>
							<SelectControl
								label={ __( 'Visibility on', 'better-chat-support-pro' ) }
								value={ visibility }
								options={ visibilityOn.map(
									( { value, label } ) => ( {
										value,
										label,
									} )
								) }
								onChange={ ( newSize ) => {
									setAttributes( { visibility: newSize } );
								} }
							/>
							<SelectControl
								label={ __( 'Size', 'better-chat-support-pro' ) }
								value={ buttonSize }
								options={ buttonSizeOptions.map(
									( { value, label } ) => ( {
										value,
										label,
									} )
								) }
								onChange={ ( newSize ) => {
									setAttributes( { buttonSize: newSize } );
								} }
							/>
							<SelectControl
								label={ __( 'Border Radius', 'better-chat-support-pro' ) }
								value={ borderRadius }
								options={ borderRadiusOptions.map(
									( { value, label } ) => ( {
										value,
										label,
									} )
								) }
								onChange={ ( newSize ) => {
									setAttributes( { borderRadius: newSize } );
								} }
							/>
						</PanelBody>
					</InspectorControls>
					<BlockControls>
						<AlignmentToolbar
							value={ textAlignment }
							onChange={ onChangeAlignment }
						/>
					</BlockControls>
					<div
						className={ `button-wrapper mSupport-editor ${ textClasses }` }
					>
						<button
							{ ...useBlockProps( {
								className: `avatar-active ${ classes } ${ buttonSize } ${ borderRadius } ${ visibility }`,
							} ) }
							data-btnavailablety={ `{ "monday":"${ mondayStart }-${ mondayEnd }", "tuesday":"${ tuesdayStart }-${ tuesdayEnd }", "wednesday":"${ wednesdayStart }-${ wednesdayEnd }", "thursday":"${ thursdayStart }-${ thursdayEnd }", "friday":"${ fridayStart }-${ fridayEnd }", "saturday":"${ saturdayStart }-${ saturdayEnd }", "sunday":"${ sundayStart }-${ sundayEnd }" }` }
							data-timezone={ timeZone }
						>
							<img
								src={ imageUrl ? imageUrl : agentImage }
								alt="agent"
							/>
							<div className="info-wrapper">
								<RichText
									onChange={ advancedBtnInfo }
									value={ info }
									placeholder={ __(
										'Robert / Sales Support',
										'better-chat-support-pro'
									) }
									tagName="p"
									allowedFormats={ [] }
									className="info"
								/>
								<RichText
									onChange={ advancedBtnTitle }
									value={ title }
									placeholder={ __(
										'How can I help you?',
										'better-chat-support-pro'
									) }
									tagName="p"
									allowedFormats={ [] }
									className="title"
								/>
								<RichText
									onChange={ advancedBtnOnlineBadge }
									value={ online }
									placeholder={ __(
										'I am online',
										'better-chat-support-pro'
									) }
									tagName="p"
									allowedFormats={ [] }
									className="online"
								/>
								<RichText
									onChange={ advancedBtnOnlineBadge }
									value={ offline }
									placeholder={ __(
										"I'm not available",
										'better-chat-support-pro'
									) }
									tagName="p"
									allowedFormats={ [] }
									className="offline"
								/>
							</div>
						</button>
					</div>
				</>
			) }
		</>
	);
}
